import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { composeErrorMessage } from "../../utils/utils";
import eventManagerService from "./eventManagerService";

const initialState = {
  events: null,
  event: null,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",

  guests: [],
  fetchingGuests: false,
  errorFetchingGuests: "",
};


export const getGuestsForEventAction = createAsyncThunk(
  "events/getGuestsForEvent",
  async (eventId, thunkAPI) => {
    try {
      return await eventManagerService.getGuestsForEvent(eventId);
    } catch (error) {
      return thunkAPI.rejectWithValue(composeErrorMessage(error));
    }
  }
);



export const checkIn = createAsyncThunk(
  "events/checkIn",
  async ({ guestId, eventId }, thunkAPI) => {
    try {
      const response = await eventManagerService.checkIn(guestId, eventId);

      thunkAPI.dispatch(getGuestsForEventAction(eventId));

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(composeErrorMessage(error));
    }
  }
);

export const checkOut = createAsyncThunk(
  "events/checkOut",
  async ({ guestId, eventId }, thunkAPI) => {
    try {
      const response = await eventManagerService.checkOut(guestId, eventId);

      thunkAPI.dispatch(getGuestsForEventAction(eventId));

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(composeErrorMessage(error));
    }
  }
);


export const eventsSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    reset: (state) => initialState,
    resetEvents: (state) => {
      state.events = null;
    },
    resetEvent: (state) => {
      state.event = null;
      state.newEvent = null;
      state.updatedEvent = null;
      state.deletedEvent = null;
    },
    resetError: (state) => {
      state.isError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGuestsForEventAction.pending, (state) => {
        state.fetchingGuests = true;
        state.guests = [];
        state.errorFetchingGuests = "";
      })
      .addCase(getGuestsForEventAction.fulfilled, (state, action) => {
        state.fetchingGuests = false;
        state.guests = action.payload;
        state.errorFetchingGuests = "";
      })
      .addCase(getGuestsForEventAction.rejected, (state, action) => {
        state.fetchingGuests = false;
        state.guests = [];
        state.errorFetchingGuests = action.payload;
      });
  },
});

export const { reset, resetEvents, resetEvent, resetError } =
  eventsSlice.actions;
export default eventsSlice.reducer;
